import { NetworkProvider } from "../api/api";
import { ChannelConfigEnum, ErrorData, FactorsEnum, ScopeEnum } from "../types";
import ChallengeType from "./challenge.types";

class Challenge {
  async createChallengeUnAuthenticated(
    factor: FactorsEnum,
    data: ChallengeType
  ): Promise<{
    success: boolean;
    exists?: boolean;
    expiry?: Record<string, string>;
    errors?: ErrorData[];
    challenge?: string;
  }> {
    const networkProvider = NetworkProvider.getInstance();
    const url = `/challenges/${factor}`;
    try {
      const response = await networkProvider.post(url, data);
      if (response?.success) {
        return {
          success: true,
          exists: true,
          challenge: response?.data?.id,
          expiry: {
            expires_at: response?.data?.expires_at,
            next_available_at: response?.data?.next_available_at
          }
        };
      } else {
        if (response?.errors?.[0]?.code === 1305) {
          return {
            success: false,
            exists: false,
            errors: response?.errors as ErrorData[]
          };
        }
        return { success: false, errors: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }
  async createNewChallengeUnAuthenticated(
    factor: FactorsEnum,
    data: ChallengeType,
    challengeId: string
  ): Promise<{
    success: boolean;
    exists?: boolean;
    errors?: ErrorData[];
    expiry?: Record<string, string>;
    challenge?: string;
  }> {
    const networkProvider = NetworkProvider.getInstance();
    const url = `/challenges/${factor}/${challengeId}`;
    try {
      const response = await networkProvider.put(url, data);
      if (response?.success) {
        return {
          success: true,
          challenge: response?.data?.id,
          expiry: {
            expires_at: response?.data?.expires_at,
            next_available_at: response?.data?.next_available_at
          }
        };
      } else {
        if (response?.errors?.[0]?.code === 1305) {
          return {
            success: false,
            exists: false,
            errors: response?.errors as ErrorData[]
          };
        }
        return { success: false, errors: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }

  async createChallengeAuthenticated(
    factor: FactorsEnum,
    data: ChallengeType,
    xAuth: string
  ): Promise<{
    success: boolean;
    exists?: boolean;
    expiry?: Record<string, string>;
    errors?: ErrorData[];
    challenge?: string;
  }> {
    const url =
      data?.scope === ScopeEnum.EmailMerge ||
      data?.scope === ScopeEnum.PhoneMerge
        ? `accounts/merge/send-otp`
        : `/accounts/me/challenges/${factor}`;
    const requestData =
      data?.scope === ScopeEnum.EmailMerge ||
      data?.scope === ScopeEnum.PhoneMerge
        ? {
            config: {
              channel: data?.channel,
              value:
                data?.scope === ScopeEnum.EmailMerge
                  ? data?.config?.[ChannelConfigEnum.Email]
                  : data?.scope === ScopeEnum.PhoneMerge
                    ? data?.config?.[ChannelConfigEnum.Phone]
                    : ""
            }
          }
        : data;
    try {
      const config = {
        headers: {
          "x-authentication": xAuth
        }
      };
      const networkProvider = NetworkProvider.getInstance();
      const response = await networkProvider.post(url, requestData, config);
      if (response?.success) {
        let challengeData;
        if (
          data?.scope === ScopeEnum.EmailMerge ||
          data?.scope === ScopeEnum.PhoneMerge
        ) {
          challengeData = {
            challenge: response?.data?.challenge?.id,
            expiry: {
              expires_at: response?.data?.challenge?.expires_at,
              next_available_at: response?.data?.challenge?.next_available_at
            }
          };
        }
        return {
          success: true,
          exists: true,
          ...(data?.scope === ScopeEnum.EmailMerge ||
          data?.scope === ScopeEnum.PhoneMerge
            ? challengeData
            : {
                challenge: response?.data?.id,
                expiry: {
                  expires_at: response?.data?.expires_at,
                  next_available_at: response?.data?.next_available_at
                }
              })
        };
      } else {
        if (response?.errors?.[0]?.code === 1305) {
          return {
            success: false,
            exists: false,
            errors: response?.errors as ErrorData[]
          };
        }
        return { success: false, errors: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }
  async createNewChallengeAuthenticated(
    factor: FactorsEnum,
    data: ChallengeType,
    challengeId: string,
    xAuth: string
  ): Promise<{
    success: boolean;
    exists?: boolean;
    expiry?: Record<string, string>;
    errors?: ErrorData[];
    challenge?: string;
  }> {
    const networkProvider = NetworkProvider.getInstance();
    const url = `/accounts/me/challenges/${factor}/${challengeId}`;
    const config = {
      headers: {
        "x-authentication": xAuth
      }
    };
    try {
      const response = await networkProvider.put(url, data, config);
      if (response?.success) {
        return {
          success: true,
          challenge: response?.data?.id,
          expiry: {
            expires_at: response?.data?.expires_at,
            next_available_at: response?.data?.next_available_at
          }
        };
      } else {
        if (response?.errors?.[0]?.code === 1305) {
          return {
            success: false,
            exists: false,
            errors: response?.errors as ErrorData[]
          };
        }
        return { success: false, errors: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }
}

export default Challenge;
